import { lazy, Suspense } from 'react';

const Detail = lazy(() => import('./ceremony-detail').then(module => ({ default: module.CeremonyDetail })));

/** Load PDF and comparison tools only when a ceremony viewer is opened. */
export function CeremonyViewer({ tenantId, ceremonyId }: { tenantId: string; ceremonyId: string }) {
  return <Suspense fallback={<p role="status">Loading ceremony…</p>}>
    <Detail key={`${tenantId}/${ceremonyId}`} tenantId={tenantId} ceremonyId={ceremonyId} />
  </Suspense>;
}
